export default __webpack_public_path__ + "media/images/banner/banner-3-0d7463cb1f9755233dfea34294ec7c17.jpg";